export default __webpack_public_path__ + "static/media/Xhighlight Logo Rectangle.d87dc485.png";